import {
  PLAYER_OPTIONS_SHOW_GRID,
  PLAYER_OPTIONS_HIDE_GRID,
} from 'containers/Player/actions/optionButtons/constants';

const initialState = {
  isOpen: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case PLAYER_OPTIONS_SHOW_GRID:
      return { isOpen: true };
    case PLAYER_OPTIONS_HIDE_GRID:
      return { isOpen: false };
    default:
      return state;
  }
};
